import React from 'react';
import { motion } from 'framer-motion';

const Receive = ({ onBack, onNavigate, t, isRTL }) => {
  const tr = t || {
    receiveTitle: 'Receive Money', receiveDesc: "Choose how you'd like to receive",
    showMyQR: 'Show My QR Code', showMyQRDesc: 'Let sender scan your personal code',
    copyLink: 'Copy Wallet Link', copyLinkDesc: 'Share your payment link',
  };

  const options = [
    { icon: '⊡', title: tr.showMyQR, desc: tr.showMyQRDesc, action: 'myqr', highlight: true },
    { icon: '📋', title: tr.copyLink, desc: tr.copyLinkDesc, action: 'copy', highlight: false },
  ];

  return (
    <div
      data-testid="receive-screen"
      className="no-scrollbar"
      style={{
        background: '#0F0F0F',
        height: '100%',
        fontFamily: 'Inter, sans-serif',
        overflowY: 'auto',
        paddingBottom: '12px',
        direction: isRTL ? 'rtl' : 'ltr',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '18px 20px 14px' }}>
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={onBack}
          style={{ width: '32px', height: '32px', borderRadius: '10px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#F5F1EA', fontSize: '16px', flexShrink: 0 }}
        >
          {isRTL ? '→' : '←'}
        </motion.button>
        <h2 style={{ color: '#F5F1EA', fontSize: '17px', fontWeight: '700', margin: 0, letterSpacing: '-0.4px' }}>{tr.receiveTitle}</h2>
      </div>

      <div style={{ padding: '0 20px' }}>
        <p style={{ color: '#8B93A7', fontSize: '12px', marginBottom: '22px' }}>{tr.receiveDesc}</p>
        {options.map((option, i) => (
          <motion.div
            key={i}
            whileTap={{ scale: 0.98 }}
            onClick={() => { if (option.action === 'myqr') onNavigate('myqr'); }}
            style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px', background: option.highlight ? 'rgba(212,175,55,0.06)' : 'rgba(255,255,255,0.03)', border: option.highlight ? '1px solid rgba(212,175,55,0.18)' : '1px solid rgba(255,255,255,0.07)', borderRadius: '17px', marginBottom: '10px', cursor: 'pointer' }}
          >
            <div style={{ width: '46px', height: '46px', borderRadius: '15px', background: option.highlight ? 'rgba(212,175,55,0.1)' : 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>{option.icon}</div>
            <div style={{ flex: 1 }}>
              <p style={{ color: '#F5F1EA', fontSize: '14px', fontWeight: '600', margin: 0 }}>{option.title}</p>
              <p style={{ color: '#8B93A7', fontSize: '11px', margin: '2px 0 0' }}>{option.desc}</p>
            </div>
            <span style={{ color: option.highlight ? '#D4AF37' : '#8B93A7', fontSize: '16px' }}>→</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Receive;
